<template>
  <nav class="nav">
    <div class="nav-menu"></div>
    <div
      :key="menu.path"
      class="nav-menu"
      v-for="(menu) in menus"
    >
      <div :key="menu.path" class="nav-menu-item">
        <router-link :to="{ path: menu.path }">
          <span :class="menu.icon" class="nav-menu-item-icon"></span>
          <span>{{ menu.label }}</span>
          <span></span>
        </router-link>
      </div>
    </div>
  </nav>
</template>
<script>
import AccountAPI from '../../model/api/accountmanage'
export default {
  name: 'TheNav',
  props: {
    list: Array
  },
  data() {
    return {
      menus: []
    }
  },
  methods: {
    getMenus() {
      return [
        {
          label: '数据概览',
          path: '/index',
          icon: 'el-icon-data-line'
        },
        {
          label: '用户管理',
          path: '/usermanage',
          icon: 'el-icon-user'
        },
        {
          label: '设备管理',
          path: '/devicemanage',
          icon: 'el-icon-tickets'
        },
        {
          label: '异常预警',
          path: '/abnormal',
          icon: 'el-icon-bell'
        },
      ]
    },
    getMenusByAdmin() {
      return [
        {
          label: '数据概览',
          path: '/index',
          icon: 'el-icon-data-line'
        },
        {
          label: '用户管理',
          path: '/usermanage',
          icon: 'el-icon-user'
        },
        {
          label: '设备管理',
          path: '/devicemanage',
          icon: 'el-icon-tickets'
        },
        {
          label: '异常预警',
          path: '/abnormal',
          icon: 'el-icon-bell'
        },
        {
          label: '账号管理',
          path: '/account',
          icon: 'el-icon-bank-card'
        }
      ]
    }
  },
  created() {
    let params = {p: this.page, size: this.size }
    AccountAPI.getAccountList(params).then(res => {
        if(res.data.msg.indexOf('没有权限') > -1) {
          this.menus = this.getMenus()
        }else{
          this.menus = this.getMenusByAdmin()
        }
    })
  }
}
</script>
<style lang="scss" scoped>
.nav {
  position: relative;
  z-index: 2;
  box-shadow: 4px 0px 10px rgba(38, 153, 251, 0.1);
  overflow-y: auto;
  &-menu {
    padding: 4px 0;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    transition: all 0.4s $bezire;
    &-item {
      font-size: 16px;
      cursor: pointer;
      user-select: none;
      & > a {
        padding: 10px 0;
        line-height: 20px;
        text-align: center;
        color: #778899;
        display: block;
        &.actived {
          color: $primary;
        }
      }
      &-icon {
        margin-right: 12px;
        width: 1em;
        height: 1em;
        display: inline-block;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        vertical-align: middle;
      }
    }
  }
}
</style>
